import React from 'react';
import { connect } from 'react-redux';

import { screen } from '$fcomponents/hoc';
import { ItemReportMain } from '../itemReportScreen/itemReportMain';

interface itemReportScreenProps {
  factory;
  history;
  match;
  stores;
  columns;
  dateFilter;
}

const OrderReportScreen: React.FC<itemReportScreenProps> = ({
  history,
  columns,
  dateFilter,
  stores,
  match,
  factory,
}) => {
  return (
    <ItemReportMain
      history={history}
      columns={columns}
      dateFilter={dateFilter}
      stores={stores}
      factory={factory}
      match={match}
      orderFlag
    />
  );
};

const mapStateToProps = (state) => ({
  factory: state.factory.factory,
  stores: state.store.stores,
  columns: state.localStorage.columns,
});

const mapDispatchToProps = {};

const connected: any = connect(mapStateToProps, mapDispatchToProps);

export default connected(screen(OrderReportScreen));
